import { h, FunctionalComponent, JSX } from 'preact';
import { MutableRef, useState } from 'preact/hooks';
import { generateId } from '../../utils/generate-id';
import { onKeyboardSelection } from '../../utils/operators';

import './toggle-button.scss';

interface ToggleButtonProps {
  reference?: MutableRef<HTMLInputElement>;
  checked: boolean;
  ariaLabel: string;
  label?: string;
  labelOn?: string;
  labelOff?: string;
  onChange: (e: JSX.TargetedEvent<HTMLInputElement>) => void;
}

export const ToggleButton: FunctionalComponent<ToggleButtonProps> = (props) => {
  const { checked, onChange, ariaLabel, reference, label, labelOn, labelOff, ...otherProps } = props;
  const [id] = useState(generateId());
  return <div
    className={`uwaw-switcher ${label ? 'uwaw-switcher_has-label' : ''}`}
  >
    {label &&
      <label htmlFor={`uwaw-${id}`}>
        <span className="uwaw-switcher__label">{label}</span>
      </label>
    }

    <label role="presentation" className="uwaw-switcher__input-label"
           htmlFor={`uwaw-${id}`} aria-label={ariaLabel}>
      <input
        role="presentation"
        id={`uwaw-${id}`}
        ref={reference}
        type="checkbox"
        className="uwaw-switcher__input"
        checked={checked}
        onInput={(e) => onChange(e)}
        onKeyDown={onKeyboardSelection((e) => onChange(e as any))}
        {...otherProps}
      />
      <span className="uwaw-switcher__outline">
            <span className="uwaw-switcher__body">
                <span className="uwaw-switcher__trigger">
                  <span aria-hidden={true} className="uwaw-switcher__state uwaw-switcher__state_on">
                    {labelOn || 'On'}
                  </span>
                  <span aria-hidden={true} className="uwaw-switcher__state uwaw-switcher__state_off">
                    {labelOff || 'Off'}
                  </span>
                </span>
          </span>
        </span>
    </label>
  </div>;
};
